import { render, staticRenderFns } from "./FacturationList.vue?vue&type=template&id=75b22f1a&scoped=true"
import script from "./FacturationList.vue?vue&type=script&lang=js"
export * from "./FacturationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b22f1a",
  null
  
)

export default component.exports